import { useQuery } from '@tanstack/react-query';
import { supabase } from '../lib/supabase';

export type ContactInfo = {
  id: string;
  type: 'ADDRESS' | 'PHONE' | 'EMAIL' | 'HOURS' | 'SOCIAL_MEDIA';
  label: string;
  value: string;
  is_primary: boolean;
  display_order: number;
  is_public: boolean;
};

// Fallback data in case the fetch fails
export const fallbackContactInfo: ContactInfo[] = [
  {
    id: '1',
    type: 'ADDRESS',
    label: 'Main Location',
    value: '123 Main Street, Winnipeg, MB R3C 1A2',
    is_primary: true,
    display_order: 1,
    is_public: true,
  },
  {
    id: '2',
    type: 'PHONE',
    label: 'Main Phone',
    value: '(204) 555-1234',
    is_primary: true,
    display_order: 2,
    is_public: true,
  },
  {
    id: '3',
    type: 'EMAIL',
    label: 'Main Email',
    value: 'info@seven8nine.com',
    is_primary: true,
    display_order: 3,
    is_public: true,
  },
  {
    id: '4',
    type: 'HOURS',
    label: 'Monday - Thursday',
    value: '4:00 PM - 12:00 AM',
    is_primary: true,
    display_order: 4,
    is_public: true,
  },
  {
    id: '5',
    type: 'HOURS',
    label: 'Friday - Saturday',
    value: '4:00 PM - 2:00 AM',
    is_primary: true,
    display_order: 5,
    is_public: true,
  },
  {
    id: '6',
    type: 'HOURS',
    label: 'Sunday',
    value: '4:00 PM - 12:00 AM',
    is_primary: true,
    display_order: 6,
    is_public: true,
  },
  {
    id: '7',
    type: 'SOCIAL_MEDIA',
    label: 'Instagram',
    value: 'https://instagram.com',
    is_primary: true,
    display_order: 7,
    is_public: true,
  },
  {
    id: '8',
    type: 'SOCIAL_MEDIA',
    label: 'Facebook',
    value: 'https://facebook.com',
    is_primary: false,
    display_order: 8,
    is_public: true,
  },
];

export const useContactInfo = () => {
  return useQuery({
    queryKey: ['contactInfo'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('contact_information')
        .select('*')
        .order('display_order', { ascending: true });

      if (error) {
        console.error('Error fetching contact info:', error);
        return fallbackContactInfo;
      }

      return data.length > 0 ? data : fallbackContactInfo;
    },
    initialData: fallbackContactInfo,
  });
};

// Helper functions to get specific types of contact info
export const getContactByType = (contacts: ContactInfo[], type: ContactInfo['type']) => {
  return contacts.filter(contact => contact.type === type);
};

export const getPrimaryContact = (contacts: ContactInfo[], type: ContactInfo['type']) => {
  return contacts.find(contact => contact.type === type && contact.is_primary);
}; 